import { Box, Divider, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import InfoBox from "./InfoBox";
import { useTranslation, Trans } from "react-i18next";


export default function DisclaimerBox() {
    const { t } = useTranslation();

    return <InfoBox title={t("disclaimer.title")} color="#e69e05" titleColor="#e69e05" backgroundColor="#FEFAF3">
      <Trans i18nKey="disclaimer.body" components={{ b: <b style={{color: "#e69e05"}} /> }} />
    </InfoBox>
}
